import classNames from "classnames/bind";

import styles from "./Notification.module.css";
import {
  CheckIcon,
  Close,
  SettingIcon,
  TickIcon,
} from "../../../../components/Icons/Icons";
import imageEmpty from "../../../../assets/images/Emty.png";
import {
  format,
  formatTimeCheckNotification,
  formatTimeHHMMSS,
  getHours,
} from "../../../../utils";
import axiosClient from "../../../../services/axiosClient";
import SettingNotification from "../../../../components/Icons/SettingNotification";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { actions } from "../../../../store";
import { StateContext } from "../../../Layout/Layout";
import { Loading } from "../../../../components";
import { BellPlustIcon } from "../../../../components/Icons/NotificationSetting/BellPlustIcon";
import { ChanelNotification } from "../../../../components/Icons/HomeHeader";
import axiosClient_v2 from "../../../../services/axiosClient_v2";
import { useTranslation } from "react-i18next";
import { alprService } from "../../../../services/api/alprService";
import PreviewImage from "../../../../components/DragUploadImage/PreviewImage";
import ModalInfoFace from "./ModalInfoFace";
import { identityHistoryFSR } from "../../../../services/api/identityHistoryFSR";
import ModalCarpark from "../../../../pages/SmartReport/ModalCarpark";
import ModalLicense from "./ModalInfoLicense";


const cx = classNames.bind(styles);

function NotificationModal({
  notificationData,
  reGetData,
  setNumber,
  detail,
  dispatch,
  tagActive,
  setTagActive,
  showSetting,
  isLoading,
  handleRefreshCount,
  setNotificationData,
  setNextTime,
  loading,
}) {
  const [modalPreview, setModalPreview] = useState({
    show: false,
    image: null,
    infoLisence: null,
  });
  const [isShowOption, setIsShowOption] = useState(false);
  const [data, setData] = useState([]);
  const { isActiveFunc, setIsActiveFunc } = useContext(StateContext);
  const { t } = useTranslation();
  const [showModalInfoFace, setShowModalInfoFace] = useState(
    {
      show: false,
      infoFace: null
    }
  );
  const [fireDetect, setFireDetect] = useState({
    path: '',
    isShow: false,
    temprature: 0
  })

  const [carPrak, setCarPark] = useState({
    isShow: false,
    path: '',
    key_point: [],
    width_image: 0,
    height_image: 0,
    polygon: []
  })

  
  useEffect(() => {
    setData(notificationData?.filter(n => n?.system === (tagActive === "tb")));
  }, [notificationData, tagActive]);
  const navigate = useNavigate();

  const refContain = useRef();

  const setInfoNotification = (data) => {
    dispatch(actions.getPathNotification(data));
    setIsActiveFunc(true);
  }

  const handlePositionRegion = (region) => {
    const listKeyPoint = [];
    const listPosition = region?.map(reg => {
      const [x1, y1, x2, y2] = reg[2];
      listKeyPoint.push(reg[1])
      return [[x1, y1], [x1, y2], [x2, y2], [x2, y1]];
    })
    return [listPosition, listKeyPoint];
  }

  const handleParseData = (detail) => {
    const stringToJson = detail?.replaceAll("'", '"');
    const infoEvent = JSON.parse(stringToJson);
    const [listPosition, listKeyPoint] = handlePositionRegion(infoEvent?.list_object_detail)
    const detailEvent = {
      ...infoEvent,
      object_detail: infoEvent?.list_object?.toString(),
      list_object_detail: listPosition,
      key_point: listKeyPoint
    }
    return detailEvent;
  }

  const handleShowCarpark = async (timeReport, cameraCode) => {
    const date = new Date(timeReport);
    try {
      const day = {
        date: format(date),
      }
      const time = {
        hour_start: `${date?.getHours()}:${date?.getMinutes()}`,
        hour_end: `${date?.getHours()}:${date?.getMinutes() + 1}`,
      }
      const res = await axiosClient_v2.get("/camAI/get-list-cam-ai/", {
        params: {
          ai_service_code: "20230222000000000008",
          camera_code: cameraCode,
          ...day,
          ...time,
          page: 1,
          size: 1,
        },
      });
      const lisstEvent = res?.data?.map(item => {
        const detail = handleParseData(item?.detail);
        return {
          ...item,
          ...detail
        }
      });
      if (lisstEvent?.length > 0) {
        const info = {
          isShow: true,
          path: lisstEvent[0]?.path,
          key_point: lisstEvent[0]?.key_point,
          width_image: lisstEvent[0]?.width_image,
          height_image: lisstEvent[0]?.height_image,
          list_object_detail: lisstEvent[0]?.list_object_detail,
          point_list: lisstEvent[0]?.point_list || [],
        };
        setCarPark(info);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleShowFireDetect = async (timeReport, cameraCode) => {
    const date = new Date(timeReport);
    try {
      const day = {
        date: format(date),
      }
      const time = {
        hour_start: `${date?.getHours()}:${date?.getMinutes()}`,
        hour_end: `${date?.getHours()}:${date?.getMinutes() + 1}`,
      }
      const res = await axiosClient_v2.get("/camAI/get-list-cam-ai/", {
        params: {
          ai_service_code: "20230222000000000007",
          camera_code: cameraCode,
          ...day,
          ...time,
          page: 1,
          size: 1,
        },
      });
      const lisstEvent = res?.data?.map(item => {
        const stringToJson = item?.detail?.replaceAll("'", '"');
        const infoEvent = JSON.parse(stringToJson);
        return {
          ...item,
          temprature: infoEvent?.temprature
        }
      });
      if (lisstEvent?.length > 0) {
        const info = {
          isShow: true,
          path: lisstEvent[0]?.path,
          temprature: lisstEvent[0]?.temprature
        };
        setFireDetect(info);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const checkTypeNotification = (type) => {
    switch (type.nameNotification) {
      case "Phát hiện chuyển động":
        window.open(
          `${process.env.REACT_APP_BASE_URL}admin/smart-report/20230222000000000001`,
          "_blank"
        );
        setInfoNotification(type);
        break;
      case "Phát hiện xâm nhập":
         handleShowPreviewImage(type.path, type.time, type.codeCamera);
        break;
      case "Phát hiện camera di chuyển":
        window.open(
          `${process.env.REACT_APP_BASE_URL}admin/smart-report/20230222000000000005`,
          "_blank"
        );
        setInfoNotification(type);
        break;
      case "Nhận dạng biển số xe":
        handleShowItem(type.path, type.time, type.codeCamera);
        break;
      case "Nhận dạng khuôn mặt":
        handleShowInfoFaceDetect(type.path, type.time, type.codeCamera);
        break;
      case "Cảnh báo cháy":
        handleShowFireDetect(type.time, type.codeCamera);
        break;
      case "Bãi đỗ xe":
        handleShowCarpark(type.time, type.codeCamera);
        break;
      case "Disconnect":
        navigate("/notification");
        break;
      default:
        showSetting(type.codeCamera);
        handleRefreshCount();
        break;
    }
  };
  const getInfoLisencePlate = async (time, cameraCode) => {
    const date = format(time);
    const hour = getHours(time);
    try {
      const params = {
        camera_code: cameraCode,
        date: date,
        hour_start: hour,
        hour_end: hour,
        page: 1,
        size: 1,
      };
      const res = await alprService.getNotification(params);
      if (res) {
        const data = res?.data[0];
        return data;
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleShowItem = async (data, time, codeCamera) => {
    let infoLisence;
    if (time && codeCamera) {
      infoLisence = await getInfoLisencePlate(time, codeCamera);
    }
    setModalPreview({
      show: !!data,
      image: data ? data : null,
      infoLisence: infoLisence,
    });
  };
   const handleShowPreviewImage= async (data) => {
    setModalPreview({
      show: !!data,
      image: data ? data : null,
      infoLisence: null,
    });
  };
  const handleCheckNotification = (
    code,
    name,
    path,
    nameCamera,
    codeCamera,
    time,
    item
  ) => {
    const hasCount = item?.detail?.includes("lần");
    const seenNotification = async (codeItem) => {
      const timeChecked = formatTimeCheckNotification(codeItem) || "";
      const res = await axiosClient_v2.put(
        `/notification/put-change-notification-seen/?time=${timeChecked}`
      );
      if (!hasCount) {
        let data = {
          path: path,
          nameCamera: nameCamera,
          nameNotification: name,
          codeCamera: codeCamera,
          time: time,
        };
        checkTypeNotification(data);
      }
      // reGetData();
      return res;
    };
    seenNotification(code);
    const listNotiSeen = data?.map((item) => {
      if (item?.time === time) {
        return {
          ...item,
          seen: true
        }
      }
      return item
    })
    setData(listNotiSeen);
  };

  const handleScroll = (e) => {
    const scroll =
      e.currentTarget.scrollHeight - e.currentTarget.scrollTop - 0.75 <=
      e.target.clientHeight + 1;
    if (scroll) {
      setNumber(10);
    }
  };

  const getInfoFaceDetect = async (time, cameraCode) => {
    try {
      const date = format(time);
      const hour = getHours(time);
      const params = {
        camera_code: cameraCode,
        date: date,
        timeEnd: hour,
        timeStart: hour,
        page: 1,
        limit: 1,
      }
      const res = await identityHistoryFSR.get(params);
      if (res?.data[0]) {
        return res?.data[0];
      }
      return 0;
    } catch (error) {
      console.log(error);
    }
  }

  const handleShowInfoFaceDetect = async (data, time, codeCamera) => {
    if (time && codeCamera) {
      const infoFace = await getInfoFaceDetect(time, codeCamera);
      if (infoFace !== 0) {
        setShowModalInfoFace({
          show: true,
          infoFace: infoFace
        })
      }
    }
  };

  const handleCloseModalInfoFace = () => {
    setShowModalInfoFace({
      show: false,
      infoFace: null
    })
  }
  return (
    <div
      className={cx("modal-notification", detail && "detail")}
      ref={refContain}
    >
      {detail ? (
        ""
      ) : (
        <div className={cx("header-notification")}>
          <div className={cx("title")}>
            <span className={cx("text-title")}>{t("header.notification")}</span>
            <span
              onClick={() => setIsShowOption(!isShowOption)}
              className={cx("icon-option")}
              style={{ cursor: "pointer" }}
            >
              <SettingNotification />
            </span>
            {isShowOption && (
              <div className={cx("option")}>
                <Link
                  to={`${process.env.REACT_APP_BASE_URL}admin/notification/setting`}
                  target="_blank"
                  className={cx("option-item")}
                  onClick={() => setIsShowOption(false)}
                >
                  <span>
                    <SettingIcon />
                  </span>
                  <span>{t("header.setupNotification")}</span>
                </Link>
                <Link
                  to={`${process.env.REACT_APP_BASE_URL}admin/notification/manage-chanel`}
                  target="_blank"
                  className={cx("option-item")}
                  onClick={() => setIsShowOption(false)}
                >
                  <span>
                    <ChanelNotification color="#000" />
                  </span>
                  <span>{t("header.chanelNotification")}</span>
                </Link>
                <Link
                  to={`${process.env.REACT_APP_BASE_URL}admin/notification/history`}
                  target="_blank"
                  className={cx("option-item")}
                >
                  <span>
                    <BellPlustIcon />
                  </span>
                  <span>{t("header.seeAll")}</span>
                </Link>
              </div>
            )}
          </div>
          <div className={cx("header")}>
            <div
              onClick={(e) => {
                if (!loading) {
                  setNotificationData([]);
                  setNextTime("");
                  setTagActive("Cảnh báo thông minh");
                }
              }}
              className={cx(
                "text",
                tagActive === "Cảnh báo thông minh" ? "active" : ""
              )}
            >
              {t("header.smartNoification")}
            </div>
            <div
              onClick={(e) => {
                if (!loading) {
                  setNotificationData([]);
                  setNextTime("");
                  setTagActive("tb");
                }
              }}
              className={cx("text", tagActive === "tb" ? "active" : "")}
            >
              {t("header.systemNotification")}
            </div>
          </div>
        </div>
      )}
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "85%",
          }}
        >
          <Loading />
        </div>
      ) : (
        <>
          {data && data.length === 0 ? (
            <div className={cx("empty")}>
              <img src={imageEmpty} alt={"empty"} />
              <p> {t("header.emptyNotification")}</p>
            </div>
          ) : (
            <>
              <div
                className={cx("body-notification", detail && "full-screen")}
                onScroll={handleScroll}
              >
                {data?.map((item, index) => {
                  return (
                    <div
                      className={cx("item-notification", "item-new")}
                      key={index}
                      onClick={(e) =>
                        handleCheckNotification(
                          item.time,
                          item.name,
                          item.path,
                          item.name_cam,
                          item.camera_code,
                          item.time,
                          item
                        )
                      }
                    >
                      {!item.seen && <span className={cx("tick")}></span>}
                      <div className={cx("time-notification")}>
                        {formatTimeHHMMSS(item.time)}
                      </div>
                      <div className={cx("header-item")}>{item.name}</div>
                      <div className={cx("title-item")}>{item.detail}</div>
                    </div>
                  );
                })}
              </div>
              {isLoading && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Loading width={20} />
                </div>
              )}
            </>
          )}
        </>
      )}
      <ModalInfoFace open={showModalInfoFace.show} onCancel={handleCloseModalInfoFace} info={showModalInfoFace.infoFace} />
      <ModalCarpark info={carPrak} handleClose={() => setCarPark({
        isShow: false,
        path: '',
        key_point: [],
        width_image: 0,
        height_image: 0,
        polygon: []
      })} />
      <ModalCarpark info={fireDetect} handleClose={() => setFireDetect({
        isShow: false,
        path: '',
        temprature: 0
      })} />
      <ModalLicense info={modalPreview} handleClose={() => setModalPreview({
        show: false,
        image: '',
        infoLisence: null
      })} />
    </div>
  );
}

NotificationModal.propTypes = {
  notificationData: PropTypes.array.isRequired,
  reGetData: PropTypes.func,
  setNumber: PropTypes.func,
  detail: PropTypes.bool,
};

export default NotificationModal;
